import React from 'react';
import CircadiaHalfWidthBarChart from '../../../../components/GraphBox/Components/CircadiaHalfWidthBarChart.tsx';
import CircadiaFullWidthBarChart from '../../../../components/GraphBox/Components/CircadiaFullWidthBarChart.tsx';
import { useSelector } from 'react-redux';
import { useGetAssetCountByManufacturerQuery } from '../../../../api/asset.api.ts';
import type { AssetsByManufacturerGraph } from '../../../../api/models/graph.model.ts';
import { selectActiveFilters } from '../../../../redux/slices/filterSlice.ts';
import { selectAssetByManufacturerView } from '../../../../redux/slices/summaryGraphViewSlice.ts';
import { selectAccount } from '../../../../redux/slices/accountSlice';

import { ASSET_BY_MANUFACTURER_CHART } from '../../../../constants/messages.tsx';

interface AssetByManufacturerChartProps {
	registerExportFn?: (exportFn: () => void) => void;
	fullWidth?: boolean;
}

const AssetByManufacturerChart: React.FC<AssetByManufacturerChartProps> = ({
	registerExportFn,
	fullWidth = false,
}) => {
	const assetsByManufacturerView = useSelector(selectAssetByManufacturerView);
	const activeFilters = useSelector(selectActiveFilters);
	const account = useSelector(selectAccount);
	const accountId = account?.accountId ?? 0;
	const sourceId = account?.sourceId ?? 0;
	const accountTypeCode = account?.accountTypeCode ?? '';

	const {
		data: assetCountByManufacturer = {
			totalAssets: [],
			totalPurchasedValue: [],
		},
	} = useGetAssetCountByManufacturerQuery(
		{ sourceId, accountId, accountTypeCode, filters: activeFilters },
		{ skip: !accountId }
	);

	const chartProps = {
		title: ASSET_BY_MANUFACTURER_CHART,
		xaxislabel: 'Manufacturer',
		yaxislabel: assetsByManufacturerView.label || '',
		data: assetCountByManufacturer[assetsByManufacturerView.id as keyof AssetsByManufacturerGraph],
		registerExportFn,
	};

	return fullWidth ? (
		<CircadiaFullWidthBarChart {...chartProps} />
	) : (
		<CircadiaHalfWidthBarChart {...chartProps} />
	);
};

export default AssetByManufacturerChart;
